<template>
    <div class="grid-x">
        <modal v-if="showModal" :type="'history-modal-delete-comment'" :data="commentToBeDeleted" @close="closeModal" @resendData="deleteComment" />
        <div class="cell large-10">
            <div ref="list" class="history-item-wrapper">
                <transition-group name="list-history" tag="div" :after-enter="(clearInterval())">
                    <div v-for="(comment, index) in sortedComments" :key="`key-${index}`" class="history-item-container" @click="setHistoryIndex(comment, index)" :class="{'system': comment.isUserNote === false}">
                        <div class="history-item-action-container" v-if="index === historyItemIndex">
                            <button v-if="index === historyItemIndex && index === showResendIndex" class="button button-log" @click.stop="resendComment(comment)">
                                <icon class="icon small-svg fill-dark-gray" name="resend" />
                                <!-- Send igen -->
                            </button>
                            <button v-else class="button button-log" @click.stop="editComment(comment)">
                                <icon class="icon small-svg fill-dark-gray" name="pencil" />
                                <!-- Rediger -->
                            </button>
                                <button class="button button-log" style="margin-left: 20px;" @click="openModal({comment, index})">
                                <icon class="icon small-svg fill-dark-gray" name="bin" />
                                <!-- Slet -->
                            </button>
                        </div>
                        <div class="history-item-profile" :class="{'system': comment.isUserNote === false}">
                            <icon class="user-svg small-svg fill-white" name="user">}</icon>
                            <span>{{comment.callerUserName}}</span>
                        </div>
                        <p>{{comment.note}}</p>
                        <span v-if="comment.updated" class="time-right"> - Opdateret: {{ comment.updated | formatDateTimeElapsed }}</span>
                        <span v-if="comment.requestLogVersionStamp || comment.taskLogVersionStamp" class="time-right">{{ comment.created | formatDateTimeElapsed }}</span>
                        <span v-else-if="index === showResendIndex" class="time-right">Mislykket</span>
                        <span v-else class="time-right flexbox-align-items">Sender...<div class="loader"></div></span>
                    </div>
                </transition-group>
            </div>
            <div class="history-add-comment">
                <div class="grid-x flexbox-align-items">
                    <div class="cell auto">
                        <textarea v-autogrow="10" v-model="newComment.note" autofocus placeholder="Skriv en note" cols="30" rows="3"></textarea>
                    </div>
                    <div>
                        <button class="button button-small" @click="addComment(newComment)">
                            Tilføj
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import modal from './../../shared/modal/modal.vue'

export default {
    name: 'history',
    components: {
        modal
    },
    data () {
        return {
            newComment: {
                note: null,
                isUserNote: null,
                created: null,
                requestId: null,
                requestLogId: null,
                requestLogVersionStamp: null,
                taskId: null,
                taskLogId: null,
                taskLogVersionStamp: null,
                updated: null
            },
            timer: null,
            historyItemIndex: null,
            showResendIndex: null,
            showModal: false
        }
    },
    props: {
        comments: {
            type: [Array]
        },
        type: {
            type: [String]
        }
    },
    computed: {
        ...mapGetters({
            userInfo: 'userInfo',
            existingEnquiry: 'getSelectedEnquiry',
            existingTask: 'getSelectedTask'
        }),
        sortedComments () {
            return this.comments.sort((a, b) => {
                if (a.created < b.created) {
                    return -1
                }
                if (a.created > b.created) {
                    return 1
                }
                return 0
            })
        }
    },
    methods: {
        ...mapActions({
            setEnquiryNote: 'setEnquiryNote',
            deleteEnquiryNote: 'deleteEnquiryNote',
            setTaskNote: 'setTaskNote',
            deleteTaskNote: 'deleteTaskNote'
        }),
        openModal (comment) {
            this.commentToBeDeleted = comment
            this.showModal = true
        },
        closeModal () {
            this.showModal = false
        },
        addComment (comment) {
            let _this = this
            let newComment = {}
            let noteObj = {}
            if (comment.note && comment.note.trim()) {
                newComment = Object.assign({}, comment)

                if (this.type === 'enquiry') {
                    if (!comment.requestLogVersionStamp) {
                        this.comments.push(newComment)
                    }

                    noteObj = {
                        'requestId': this.existingEnquiry.requestId,
                        'requestLogId': newComment.requestLogId || null,
                        'note': newComment.note,
                        'requestLogVersionStamp': newComment.requestLogVersionStamp || null
                    }
                } else if (this.type === 'task') {
                    if (!comment.taskLogVersionStamp) {
                        this.comments.push(newComment)
                    }
                    noteObj = {
                        'taskId': this.existingTask.taskId,
                        'taskLogId': newComment.taskLogId || null,
                        'note': newComment.note,
                        'taskLogVersionStamp': newComment.taskLogVersionStamp || null
                    }
                }

                Object.keys(this.newComment).forEach(comment => { this.newComment[comment] = null })

                this.timer = setInterval(function () {
                    if (_this.$refs.list) {
                        _this.$refs.list.scrollTop = _this.$refs.list.scrollHeight
                    }
                }, 10)

                new Promise((resolve, reject) => {
                    if (this.type === 'enquiry') {
                        resolve(this.setEnquiryNote(noteObj))
                    } else if (this.type === 'task') {
                        resolve(this.setTaskNote(noteObj))
                    }
                }).then((response) => {
                    if (response.status === 200) {
                        if (this.type === 'enquiry') {
                            if (newComment.requestLogId) {
                                for (let i = 0; i < this.comments.length; i++) {
                                    if (this.comments[i].requestLogId === newComment.requestLogId) {
                                        this.comments[i].requestLogVersionStamp = response.data.requestLogVersionStamp
                                        this.comments[i].requestLogId = response.data.requestLogId
                                        this.comments[i].updated = response.data.updated || null
                                        this.comments[i].requestId = this.existingEnquiry.requestId
                                        this.comments[i].note = newComment.note
                                        this.historyItemIndex = null
                                        break
                                    }
                                }
                            } else {
                                let index = this.comments.indexOf(newComment)
                                if (index > -1) {
                                    this.comments[index].requestLogVersionStamp = response.data.requestLogVersionStamp
                                    this.comments[index].requestLogId = response.data.requestLogId
                                    this.comments[index].updated = response.data.updated || null
                                    this.comments[index].requestId = this.existingEnquiry.requestId
                                    this.comments[index].created = new Date()
                                    this.historyItemIndex = null
                                } else {
                                    this.$notify({group: 'info', type: 'warn', title: '', text: 'Noget gik galt. Prøv igen'})
                                }
                            }
                        } else if (this.type === 'task') {
                            if (newComment.taskLogId) {
                                for (let i = 0; i < this.comments.length; i++) {
                                    if (this.comments[i].taskLogId === newComment.taskLogId) {
                                        this.comments[i].taskLogVersionStamp = response.data.taskLogVersionStamp
                                        this.comments[i].taskLogId = response.data.taskLogId
                                        this.comments[i].updated = response.data.updated || null
                                        this.comments[i].taskId = this.existingTask.taskId
                                        this.comments[i].note = newComment.note
                                        this.historyItemIndex = null
                                        break
                                    }
                                }
                            } else {
                                let index = this.comments.indexOf(newComment)
                                if (index > -1) {
                                    this.comments[index].taskLogId = response.data.taskLogId
                                    this.comments[index].taskLogVersionStamp = response.data.taskLogVersionStamp
                                    this.comments[index].updated = response.data.updated || null
                                    this.comments[index].taskId = this.existingTask.taskId
                                    this.comments[index].created = new Date()
                                    this.historyItemIndex = null
                                } else {
                                    this.$notify({group: 'info', type: 'warn', title: '', text: 'Noget gik galt. Prøv igen'})
                                }
                            }
                        }
                    } else {
                        this.historyItemIndex = this.historyItemIndex === null ? this.comments.length - 1 : this.historyItemIndex
                        this.showResendIndex = this.historyItemIndex
                    }
                })
            }
        },
        deleteComment (data) {
            this.closeModal()
            this.$delete(this.comments, data.index)
            this.historyItemIndex = null
            if (this.type === 'enquiry') {
                this.deleteEnquiryNote(data.comment)
            } else if (this.type === 'task') {
                this.deleteTaskNote(data.comment)
            }
        },
        resendComment (comment, index) {
            if (this.type === 'enquiry') {
                this.$delete(this.comments, index)
                this.deleteEnquiryNote(comment)
                this.historyItemIndex = null
            } else if (this.type === 'task') {

            }
        },
        editComment (comment) {
            this.newComment = Object.assign({}, comment)
        },
        clearInterval () {
            setTimeout(() => {
                clearInterval(this.timer)
            }, 1000)
        },
        setHistoryIndex (comment, index) {
            this.historyItemIndex = comment.isUserNote !== false && this.historyItemIndex !== index ? index : null
        }
    },
    created () {
        let _this = this
        this.timer = setInterval(function () {
            if (_this.$refs.list) {
                _this.$refs.list.scrollTop = _this.$refs.list.scrollHeight
            }
        }, 10)

        this.newComment.callerUserName = this.userInfo.name
    }
}
</script>



// WEBPACK FOOTER //
// src/components/shared/history/history.vue